<template>
  <div v-if="isShow" class="bg_white" v-html="html"></div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
<!-- <img src="../../assets/images/birthday01_1024.png" alt=""> -->
</template>

<script>
import Check from '@/model/getToken'
import Notification from '@/components/api/notifications'

export default {
   // template: `<div v-html='inner_html'></div>`,
  data() {
    return {
      isShow: true,
      html: ''
    }
  },
  methods: {
    apiGetNotificationMessage(notificationId) {
      Notification.getInformation(notificationId).then((val) => {
        console.log(val);
        this.html  = val.bodyElement;
      });
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
// console.log(res);
    if(res) {
      if(this.$route.query.notificationId) {
        await this.apiGetNotificationMessage(this.$route.query.notificationId);
      } else {
        this.isShow = false;
      }

    } else {
      this.isShow = false;
    }

  }
}
</script>

<style lang="css" scoped>
/* リセットCSSの読み込み */
>>> body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, form,
fieldset, input, textarea, p, blockquote, th, td{
  margin: 0;
  padding: 0;
}
>>> html{
  overflow-y: scroll;
}
>>> h1, h2, h3, h4, h5, h6{
  font-size: 100%;
  font-weight: normal;
}
>>> ol, ul{
  list-style:none;
}
>>> fieldset, img{
  border:0;
}

>>> img{
  max-width: 100%;
  vertical-align: bottom;
}

>>> table{
  border-collapse: collapse;
  border-spacing:0;
}
>>> caption, th{
  text-align: left;
}
>>> a:focus {
  outline:none;
}
>>> address, caption, cite, code, dfn, em, th, var{
  font-style: normal;
  font-weight: normal;
}


/* ----------------------
共通
------------------------- */
>>> .content{
  font-size: 14px;
}

/* 改行用 */
>>> .br768on{
  display:none;
}
>>> .br480on{
  display:none;
}
>>> .br375on{
  display:none;
}

/* レスポンシブ時の切り替え用 */
>>> .sp768on{
  display:none;
}
>>> .sp480on{
  display:none;
}
>>> .sp375on{
  display:none;
}
@media screen and (max-width:768px){
  >>> .br768off{
    display:none;
  }
  >>> .sp768off{
    display:none;
  }
  >>> .br768on{
    display:block;
  }
  >>> .sp768on{
    display:block;
  }
}
@media screen and (max-width:480px){
  >>> .br480off{
    display:none;
  }
  >>> .sp480off{
    display:none;
  }
  >>> .br480on{
    display:block;
  }
  >>> .sp480on{
    display:block;
  }
}
@media screen and (max-width:375px){
  >>> .br375off{
    display:none;
  }
  >>> .sp375off{
    display:none;
  }
  >>> .br375on{
    display:block;
  }
  >>> .sp375on{
    display:block;
  }
}


>>> .content{
  padding: 0 20px;
}

>>> .sec1{
  margin-bottom: 30px;
}
>>> .sec1 .img-box {
  margin-right: calc(50% - 50vw);
	margin-left: calc(50% - 50vw);
}
>>> .sec2 h1 {
  border-bottom: 2px solid  #4FCCD4;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}

>>> .sec2 .text p {
  line-height: 1.5;
  margin-bottom: 15px;
}

>>> .sec2 .link{
  margin: 20px 0;
}

>>> .sec2 .link a {
  color: #0088ff;
  text-decoration: none;
  padding-bottom: 1px;
  border-bottom: 1px solid;
}

>>> .sec2 .list li{
  /* padding-left: 15px; */
  position: relative;
  margin: 3px 0;
}

>>> .sec2 .list li::before{
  /* content:'・'; */
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

>>> .footer_image {
  margin-right: calc(50% - 50vw);
	margin-left: calc(50% - 50vw);
}

>>> .regist_content {
  min-height: 100vh;
  position: relative;
  padding-bottom: calc(calc(1862 * 100vw / 3300) - 10px);
}

>>> .regist_footer {
  bottom: 0;
  left: 0;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/notification/Information.vue